<template>
<ValidationObserver v-slot="{ handleSubmit }">
    <form class="form-horizontal"  @submit.prevent="handleSubmit(submit)">
         <h5 v-if="id==0" slot="header" >
           Add Template
          </h5>
          <h5 v-else slot="header" >
           Edit Template
          </h5>
        <table width="100%">
          <tbody>
               <tr>
                 <td style="width:25%">Title : </td>
                 <td style="width:75%">
                     <ValidationProvider
                     name="name"
                    rules="required"
                    v-slot="{ passed, failed }"
                     >
                     <fg-input 

                     type="text" 
                     :error="failed ? 'The title field is required': null"
                     :hasSuccess="passed"                      
                     name="title"
                     v-model="title"
                     placeholder="Enter title"
                     >
                     </fg-input> 
                     </ValidationProvider> 
                     </td>
               </tr>
              <tr>
                <td style="width:15%">Message : </td>
                <td style="width:85%">
                     <textarea class="form-control" rows="3" 
                     name="message" v-model="message"
                     placeholder="Enter your message"
                    >
                    </textarea><br>
                    </td>
            </tr>
             <tr>
              <td colspan="2">
                  <el-button v-if="id==0" class="float-right" type="primary" native-type="submit">Save</el-button>
                   <el-button v-else class="float-right" type="primary" native-type="submit">Update</el-button>
             </td>
            </tr>
        </tbody>
      </table>
   </form>
  </ValidationObserver>
</template>
<script>
import { required, confirmed } from "vee-validate/dist/rules";
import toast from '../../../UIComponents/ToastNotifier.js'
import Swal from 'sweetalert2'
import { extend } from "vee-validate";
import api from "@/services/MessagingTemplate/MessagingTemplateServices.js";
export default {
    components:{
      Swal,
    },
    props:{      
      title:'',
      message:'',
      id:0
    },
    data(){
        return{
           practice:this.$store.getters["currentUser/getCurrentUsersPractice"], 
          createdby:this.$store.getters["currentUser/getCurrentUsersLogin"],
        }
    },
    methods:{
       async submit(){
          var templateDetails={
            practiceCode: this.practice.toUpperCase(),
            template_name: this.title,
            template_message: this.message,
            created_by: this.createdby,
            id:this.id
          }
        var result= await api.AddUpdateMessagingTemplate(templateDetails);
        if(result.result)
        {
         this.$notify({
          title: "Template saved",
          horizontalAlign: "left",
          verticalAlign: "bottom",
          type: "success",
          timeout: 1000,
          showClose: false,
        });
       this.ResetForm();
       this.$emit('refresh-list','data saved')
        }
        else{
           this.$notify({
          title: "Something went wrong!",
          horizontalAlign: "left",
          verticalAlign: "bottom",
          type: "error",
          timeout: 1000,
          showClose: false,
        });
        this.ResetForm();
        }

        },
      ResetForm(){              
       this.title="";
       this.message="";
     },
    }
    
}
</script>
<style scoped>

</style>